import { useRef } from "react";
import { useRecoilValue } from "recoil";

import { isLoggedInAtom } from "@ryde/shared";

export const useLoggedInRef = (): { readonly current: boolean } => {
  const isLoggedIn = useRecoilValue(isLoggedInAtom);
  const isLoggedInRef = useRef(isLoggedIn);
  isLoggedInRef.current = isLoggedIn;
  return isLoggedInRef;
};
